<div class="trading-view-widget">
	<app-trading-view />
</div>
